import React from "react";
import { useState, useEffect } from "react";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

const DashboardLayout = ({ children }) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

  useEffect(() => {
    const savedState = localStorage.getItem("isSidebarExpanded");
    if (savedState !== null) {
      setIsSidebarExpanded(JSON.parse(savedState));
    }
  }, []);

  const handleSidebarToggle = (newState) => {
    setIsSidebarExpanded(newState);
    localStorage.setItem("isSidebarExpanded", JSON.stringify(newState));
  };

  return (
    <div className="dashboard-layout vh-100 d-flex">
      <Sidebar onToggle={handleSidebarToggle} />
      <div
        className="main-content flex-grow-1 d-flex flex-column"
        style={{
          marginLeft: isSidebarExpanded ? "250px" : "72px",
          width: isSidebarExpanded ? "calc(100% - 250px)" : "calc(100% - 72px)",
          transition: "all 0.3s ease",
        }}
      >
        <Header />
        {/* The content container will grow to fill space */}
        <div
          className="content flex-grow-1 text-light container"
          style={{
            paddingLeft: isSidebarExpanded ? "15px" : "0px",
            paddingRight: isSidebarExpanded ? "15px" : "0px",
            paddingTop: "56px",
          }}
        >
          {children}
        </div>
        {/* Footer placed at the bottom */}
        <Footer />
      </div>
      <style>
        {`
          @media (max-width: 768px) {
            .main-content {
              margin-left: 72px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default DashboardLayout;